import { render, staticRenderFns } from "./vchart.vue?vue&type=template&id=6bad431d&scoped=true&"
import script from "./vchart.vue?vue&type=script&lang=js&"
export * from "./vchart.vue?vue&type=script&lang=js&"
import style0 from "./vchart.vue?vue&type=style&index=0&id=6bad431d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad431d",
  null
  
)

export default component.exports